import makeStyles from "@mui/styles/makeStyles";
import { Bold, Regular, remCalc } from "../../utils";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0px",
    backgroundColor: "#F2F5FA",
  },
  formBox: {
    padding: "16px",
    overflow: "overlay",
  },
  form: {
    padding: "12px",
    borderRadius: "12px",
    boxShadow: "0px 3px 30px #5C86CB2E",
    backgroundColor: "#FFFFFF",
  },
  formMiniCard: {
    backgroundColor: "#F5F7FA",
    borderRadius: "8px",
    padding: "12px",
  },
  surveyIcon: {
    width: "48px",
    height: "48px",
  },
  formMiniCardTitle: {
    fontSize: remCalc(14),
    fontFamily: Bold,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#091B29"
  },
  formMiniCardFormNo: {
    fontSize: remCalc(12),
    fontFamily: Regular,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#4E5A6B"
  },
  submitButtonBox: {
    padding: "16px",
    backgroundColor: "#FFFFFF",
  },
  submitButton: {
    padding: "12px 16px",
    borderRadius: "8px",
    boxShadow: "none",
    backgroundColor: "#5078E1",
    "&:hover": {
      backgroundColor: "#5078E1",
      opacity: 0.9,
      boxShadow: "none",
    },
  },
  submitButtonText: {
    color: "#FFFFFF",
    fontFamily: Bold,
    fontSize: remCalc(14),
    textTransform: "capitalize",
  },
}));